/**
 * Humanizes a tool name for display.
 * Composio tools use SCREAMING_SNAKE_CASE (e.g. GMAIL_SEND_EMAIL) → "Gmail: Send email"
 * Other tools use snake_case or camelCase → "Send email"
 */
export function formatToolName(name: string): string {
  // Detect SCREAMING_SNAKE_CASE (Composio tools): all-uppercase with underscores
  if (/^[A-Z][A-Z0-9_]+$/.test(name)) {
    const parts = name.split('_');
    // First segment is the app name, rest is the action
    const app = parts[0].charAt(0) + parts[0].slice(1).toLowerCase();
    const action = parts
      .slice(1)
      .map((p) => p.toLowerCase())
      .join(' ');
    return action ? `${app}: ${action.charAt(0).toUpperCase() + action.slice(1)}` : app;
  }

  // Regular snake_case or camelCase
  return name
    .replace(/_/g, ' ')
    .replace(/([A-Z])/g, ' $1')
    .trim()
    .toLowerCase()
    .replace(/^\w/, (c) => c.toUpperCase());
}
